export default __webpack_public_path__ + "static/media/LookingSpecCenterImage.202b9421.svg";